export const RESERVABLES_SEARCH_DAYS_COUNT = 45
